<template>
  <el-form ref="loginForm" :model="loginForm" :rules="loginRules">
    <el-form-item prop="name" class="form-item">
      <el-input
        prefix-icon=""
        v-model="loginForm.name"
        maxlength="50"
        :placeholder="$t('login.userName')"
      >
        <template slot="prefix">
          <img src="@/static/img/login/login_icon_name_disable.png" />
        </template>
      </el-input>
    </el-form-item>
    <el-form-item prop="password" class="form-item">
      <el-input
        v-model="loginForm.password"
        maxlength="50"
        type="password"
        :placeholder="$t('login.password')"
      >
        <template slot="prefix">
          <img src="@/static/img/login/login_icon_password_disable.png" />
        </template>
      </el-input>
    </el-form-item>
    <el-form-item prop="vfCode" class="form-item vfCode">
      <div class="vfCode-inner">
        <img @click="handleChangeVfCode" :src="vfCodeImgBase64" />
        <el-input v-model="loginForm.vfCode" placeholder="输入验证码">
        </el-input>
      </div>
    </el-form-item>
    <el-form-item>
      <el-button
        type="primary"
        size="small"
        @click="handleLogin"
        :loading="loading"
        :disabled="loading"
        class="submit-btn"
      >
        {{ submitText || $t("login.login") }}
      </el-button>
      <!-- <el-button size="small" @click="handleReset('loginForm')">
              {{ $t("login.reset") }}
            </el-button> -->
    </el-form-item>
    <el-row type="flex" justify="center">
      <el-button type="text" @click="supply" class="hidden-xs-only">
      </el-button>
    </el-row>
  </el-form>
</template>

<script>
import md5 from "md5";
import { CONST_PASSWORD_SLOT } from "@/config/constant";
import { mapActions } from "vuex";
import authApi from "@/api/auth";

export default {
  props: {
    submitText: {
      type: String,
      default: ""
    },
    redirectAfterLogin: {
      type: String,
      default: "/home"
    }
  },
  data() {
    return {
      uniqueId: "",
      vfCodeImgBase64: "",
      loading: false,
      loginForm: {
        name: "",
        password: "",
        vfCode: ""
      },
      loginRules: {
        name: [
          {
            required: true,
            trigger: "blur",
            message: this.$t("login.enterUserName")
          }
        ],
        password: [
          {
            required: true,
            trigger: "blur",
            message: this.$t("login.enterPassword")
          }
        ],
        vfCode: [
          {
            required: true,
            trigger: "blur",
            message: "请输入验证码"
          }
        ]
      }
    };
  },
  mounted() {
    authApi.getVfCode().then(res => {
      this.uniqueId = res.uniqueId;
      this.vfCodeImgBase64 = res.vfCodeImgBase64;
    });
  },
  computed: {},
  methods: {
    ...mapActions(["initData"]),
    handleChangeVfCode() {
      authApi
        .getVfCode({
          uniqueId: this.uniqueId
        })
        .then(res => {
          this.uniqueId = res.uniqueId;
          this.vfCodeImgBase64 = res.vfCodeImgBase64;
        });
    },
    handleLogin() {
      this.loading = true;
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.$store
            .dispatch("login", {
              accountId: this.loginForm.name,
              type:
                /^1\d{10}$/.test(this.loginForm.name) == true
                  ? "MOBILE"
                  : "MAIL",
              password: md5(
                this.loginForm.password + CONST_PASSWORD_SLOT
              ).toLowerCase(),
              vfCode: this.loginForm.vfCode,
              vfCodeUniqueId: this.uniqueId
            })
            .then(res => {
              if (res) {
                this.initData().then(res => {
                  this.$emit("login-success");
                  if (this.redirectAfterLogin) {
                    window.location.href = this.redirectAfterLogin;
                  }
                });
              } else {
                this.$message.error("登录失败，请稍后重试");
              }
              this.loading = false;
            })
            .catch(res => {
              this.handleChangeVfCode();
              this.loading = false;
            });
        } else {
          this.loading = false;
        }
      });
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    supply() {
      this.$emit("on-supply");
    }
  }
};
</script>

<style lang="scss">
.submit-btn {
  display: block;
  width: 100%;
  height: 36px;
  background-color: rgb(51, 153, 255);
  font-size: 16px;
  margin-top: 20px;
}

.submit-btn:hover,
.submit-btn:focus {
  background-color: #99ccff;
  border-color: #99ccff;
}

.el-form-item.form-item {
  margin-bottom: 24px;

  .el-input__inner {
    height: 36px;
    padding-left: 54px;
    background: rgba(255, 255, 255, 0);
    border-color: rgb(238, 238, 238);
  }

  .el-input__prefix {
    left: 0;

    img {
      margin: 7px 16px;
    }
  }
}

.el-form-item.form-item.vfCode {
  .el-input__inner {
    padding-left: 5px;
  }
}

.vfCode-inner {
  display: flex;
  align-items: center;
}
</style>
